<section>
  <ng-container *dgxGroupFilterToggle>
    <div
      *ngIf="groups"
      dgxSticky
      class="dg-sticky"
      [stickyFullWidth]="true"
      [stickyCustomClass]="'box-shadow bg-color-ebony-a03'"
      [notStickyCustomClass]="'grid__col-12 guts-p-t-2 guts-p-b-0'"
    >
      <div
        class="l_flexbar bg-color-ebony-a03-hue rounded--large m-l_flexbar-block guts-p-full-1"
      >
        <div class="l_flexbar m-l_flexbar-block">
          <div class="m-guts-m-t-half">
            <!-- Group -->
            <dgx-combobox
              class="m-full-width"
              [ariaLabel]="i18n.OrgReportingCtrl_FilterByGroup"
              [hasNoResultsText]="i18n.OrgReportingCtrl_NoMatchingGroups"
              [isExactMatchesEnabled]="true"
              [options]="groups"
              [placeholder]="i18n.OrgReportingCtrl_FilterByGroup"
              (selection)="onChangeGroup($event)"
              [labelKey]="'name'"
              [trackBy]="'groupId'"
              dgatInput="insights-447"
            >
            </dgx-combobox>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <dgx-kpi-insights
    [orgId]="orgId"
    [targetId]="target?.targetId"
    [startDate]="dateRange?.startDate"
    [endDate]="dateRange?.endDate"
    [groupId]="selectedGroup?.groupId"
  ></dgx-kpi-insights>
  <dgx-activity-insights
    class="grid__col-sm-12"
    [orgId]="orgId"
    [planId]="target?.targetId"
    [groupId]="selectedGroup?.groupId"
    data-dgat="activity-insights-container"
  >
  </dgx-activity-insights>

  <ng-container *ngIf="showCombinedPlanInsights; else legacyPlanInsights">
    <ng-container *ngIf="!disableRatingsInsights">
      <ng-container
        *ngxComponentOutlet="
          resolver | async | resolve: 'dgxSkillSectionsChart';
          context: {
            orgId: orgId,
            target: target,
            sectionDetails: tagFlexSectionDetails,
            groupId: selectedGroup?.groupId,
            hostClass: 'grid__col-sm-12'
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container
      *ngxComponentOutlet="
        resolver | async | resolve: 'dgxPathwaySectionsChart';
        context: {
          orgId: orgId,
          target: target,
          targetSection: pathwayFlexSectionDetails,
          groupId: selectedGroup?.groupId,
          hostClass: 'grid__col-sm-12'
        }
      "
    ></ng-container>
    <dgx-content-insights
      class="grid__col-sm-12"
      [orgId]="orgId"
      [target]="target"
      [sectionDetails]="inputFlexSectionDetails"
      [groupId]="selectedGroup?.groupId"
    ></dgx-content-insights>
  </ng-container>

  <dgx-skill-and-role-plan-tracking-links
    class="grid__col-sm-12"
    *ngIf="displayTrackableLinks"
    [target]="target"
  >
  </dgx-skill-and-role-plan-tracking-links>
</section>

<ng-template #legacyPlanInsights>
  <div
    *ngFor="let section of sections"
    [ngSwitch]="section.resourceType"
    data-dgat="insights-df8"
  >
    <ng-container *ngIf="!disableRatingsInsights">
      <ng-container *ngSwitchCase="'Tag'">
        <ng-container
          *ngxComponentOutlet="
            resolver | async | resolve: 'dgxSkillSectionsChart';
            context: {
              orgId: orgId,
              target: target,
              section: section,
              groupId: selectedGroup?.groupId,
              hostClass: 'grid__col-sm-12'
            }
          "
        ></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'Pathway'">
      <ng-container
        *ngxComponentOutlet="
          resolver | async | resolve: 'dgxPathwaySectionsChart';
          context: {
            orgId: orgId,
            target: target,
            targetSection: section,
            groupId: selectedGroup?.groupId,
            hostClass: 'grid__col-sm-12'
          }
        "
      ></ng-container>
    </ng-container>
    <dgx-content-insights
      *ngSwitchCase="'Input'"
      class="grid__col-sm-12"
      [orgId]="orgId"
      [target]="target"
      [section]="section"
      [groupId]="selectedGroup?.groupId"
    ></dgx-content-insights>
  </div>
</ng-template>
